import { render } from "./Subject.vue?vue&type=template&id=bf96e610&scoped=true"
import script from "./Subject.vue?vue&type=script&lang=js"
export * from "./Subject.vue?vue&type=script&lang=js"

import "./Subject.vue?vue&type=style&index=0&id=bf96e610&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf96e610"]])

export default __exports__